import { Grid, Typography } from "@mui/material";
import styles from "../Information.module.scss";
import GridTableComponent from "../../common/GridTableComponent/gridTableTemplate";

const WeeklyMonthlySerrvices = () => {
  const ItemAddedData = [
    {
      Service: "Ganesha Gakara Sahasranama Archana",
      Day: "Tuesday",
      Time: "7:00 PM",
    },
    {
      Service: "Abhishekam",
      Day: "Sunday",
      Time: "10:00 AM",
    },
    {
      Service: "Abhisheka & Archana",
      Day: "Sankatahata Hara Chaturthi(4th day after full moon)",
      Time: "6:30 PM",
    },
  ];
  const TableDataForShiva = [
    {
      Service: "Suprabhatam",
      Day: "Everyday",
      Time: "9:00 AM",
    },
    {
      Service: "Abhishekam",
      Day: "Everyday",
      Time: "9:30 AM",
    },
    {
      Service: "Swarna Kavacha Alamkaram",
      Day: "1st Saturday",
      Time: "9:30 AM",
    },
    {
      Service: "Muttangialamkaram",
      Day: "2nd Saturday",
      Time: "9:30 AM",
    },
    {
      Service: "Rajitha Kavacha alamkaram",
      Day: "3rd Saturday",
      Time: "9:30 AM",
    },
    {
      Service: "Vastra Alamkaram and SwarnaMukhavada",
      Day: "4th Saturday",
      Time: "9:30 AM",
    },
    {
      Service: "Abhishekam and RudraTrisatiArchana",
      Day: "Pradosham",
      Time: "6:00 PM",
    },
    {
      Service: "Sahasranama Archana",
      Day: "3rd Sunday",
      Time: "10:00 AM",
    },
    {
      Service: "108 KalashaAbhishekam for Shiva &RajitaBilvaArchana",
      Day: "Masa Shivaratri",
      Time: "6:00 PM",
    },
    {
      Service: "Shiva Kalyanam",
      Day: "	2nd Sunday (on request)",
      Time: "3:00 PM",
    },
  ];
  const TableVenkateshwara = [
    {
      Service: "Suprabhatam",
      Day: "Everyday",
      Time: "9:00 AM",
    },
    {
      Service: "Abhishekam",
      Day: "Saturday",
      Time: "10:00 AM",
    },
    {
      Service: "Vastrasamarpana followed by VajraKireetaalamkaram",
      Day: "1st Saturday",
      Time: "9:30 AM",
    },
    {
      Service: "ThomalaSeva with Muttangialamkaram",
      Day: "2nd Saturday",
      Time: "11:30 AM",
    },
    {
      Service: "ThiruppavadaSeva with Rajitha Kavacha alamkaram",
      Day: "3rd Saturday",
      Time: "11:30 AM",
    },
    {
      Service: "PoolangiSeva (or PushpaSeva)",
      Day: "4th Saturday",
      Time: "11:30 AM",
    },
    {
      Service: "Sahasranama Archana",
      Day: "Monday - Friday & Sunday",
      Time: "9:30 PM",
    },
    {
      Service: "Sahasranama Archana",
      Day: "On Shravananakshatra",
      Time: "6:30 PM",
    },
    {
      Service: "Balaji Bhoga Murthy Abhishekam & Archana Aswameda Parayanam",
      Day: "On Ekadasi",
      Time: "6:00 PM",
    },
    {
      Service: "Nija Netra & Pada Darsanam",
      Day: "Every Friday",
      Time: "All day",
    },
    {
        Service: "Narasimha Abhishekam & Sahasranama Archana",
        Day: "On Swathinakshatra",
        Time: "6:00 PM",
      },
      {
        Service: "Balaji Kalyanam",
        Day: "Saturday (on request)",
        Time: "3:00 PM",
      },
  ];

  const TableDataForDasapuja = [
    {
      Service: "Abhishekam",
      Day: "Friday",
      Time: "10:30 AM",
    },
  ];

  const columnMappingForDasapuja = {
    Service: "Service",
    Day: "Day",
    Time: "Tiime",
  };
  const TableDataForParvati = [
    {
      Service: "Abhishekam",
      Day: "Friday",
      Time: "10:30 AM",
    },
    {
      Service: "Parvati Sahasranama Archana",
      Day: "Friday",
      Time: "6:30 PM",
    },
    {
      Service: "Lalita Sahasranama Parayana",
      Day: "Poornima",
      Time: "6:30 PM",
    },
  ];

  const columnMapping = {
    Service: "Service",
    Day: "Day",
    Time: "Time",
  };
  const columnMappingForShiva = {
    Service: "Service",
    Day: "Day",
    Time: "Time",
  };
  const columitemAddedData = {
    Service: "Service",
    Day: "Day",
    Time: "Time",
  };

  const tableKanakaDurga = [
    {
      Service: "Kanaka Durga Abhishekam and Sahasranama Archana",
      Day: "Sunday",
      Time: "04:30 PM",
    },
  ];

  const TableKarthikeya = [
    {
      Service: "Abhishekam",
      Day: "Sunday",
      Time: "11:30 AM",
    },
    {
      Service: "Sahasranama Archana",
      Day: "On Shukla Sashti",
      Time: "6:30 PM",
    },
    {
      Service: "Abhishekam & Archana",
      Day: "On Krittika",
      Time: "6:00 PM",
    },
    {
      Service: "Subramanya Kalyanam",
      Day: "	3rd Sunday (on request)",
      Time: "3:00 PM",
    },
  ];

  const tableSaraswathi = [
    {
      Service: "Abhishekam & Sahasranama Archana",
      Day: "On Moola Nakshatram",
      Time: "06:00 PM",
    },
  ];
  const tableAyyappa = [
    {
      Service: "Abhishekam & Archana",
      Day: "On Uttara Phalguni",
      Time: "06:00 PM",
    },
  ];
  const tableNavagraha = [
    {
      Service: "Abhishekam & Archana",
      Day: "Saturday",
      Time: "11:00 AM",
    },
  ];
  const tableKalabhairava = [
    {
      Service: "Abhishekam & Sahasranama Archana",
      Day: "4th Sunday",
      Time: "04:30 PM",
    },
  ];
  const tableNandi = [
    {
      Service: "Abhishekam",
      Day: "Thursday",
      Time: "10:30 AM",
    },
  ];

  const TableMahaLakshmi = [
    {
      Service: "Abhishekam",
      Day: "Friday",
      Time: "10:30 AM",
    },
    {
      Service: "Lakshmi Sahasranama Archana",
      Day: "Friday",
      Time: "6:30 PM",
    },
   
  ];
  const TableRama = [
    {
      Service: "Sahasranama Archana",
      Day: "On Punarvasunakshatram",
      Time: "10:30 AM",
    },
    {
        Service: "Abhishekam & Archana",
        Day: "On Punarvasunakshatram",
        Time: "6:00 PM",
      },
   
  ];

  const TableAndalBoodhevi = [
    {
      Service: "Abhishekam",
      Day: "Friday",
      Time: "9:30 AM",
    },
    {
      Service: "Sahasranama Archana",
      Day: "Friday",
      Time: "10:30 AM",
    },
   
  ];


  const tableKrishna = [
    {
      Service: "Abhishekam & Sahasranama Archana",
      Day: "On Rohini nakshatra",
      Time: "6:00 PM",
    },
  ];
  const tableNarasimha = [
    {
      Service: "Abhishekam & Sahasranama Archana",
      Day: "On Swati nakshatra",
      Time: "6:00 PM",
    },
  ];
  const tableAnjaneya = [
    {
      Service: "Abhishekam & Sahasranama Archana",
      Day: "Saturday",
      Time: "3:00 PM",
    },
  ];
  const tableDwarakaLast = [
    {
      Service: "Abhishekam",
      Day: "Thursday",
      Time: "10:30 AM",
    },
  ];
  return (
    <>
      <div className={styles.WeeklyMonthlySerrvices}>
        <div className={styles.cardContainer}>
          <div>
            <Grid sx={{ margin: "0px 0 20px 0" }}>
              <Typography className={styles.typoGraphyHeading}>
                Ganesha
              </Typography>
            </Grid>
            <GridTableComponent
              tableData={ItemAddedData}
              columnMapping={columitemAddedData}
            />
            <Grid sx={{ margin: "20px 0 20px 0" }}>
              <Typography className={styles.typoGraphyHeading}>
                Shiva
              </Typography>
            </Grid>
            <GridTableComponent
              tableData={TableDataForShiva}
              columnMapping={columnMappingForShiva}
            />
            <Grid sx={{ margin: "20px 0 20px 0" }}>
              <Typography className={styles.typoGraphyHeading}>
                Dasabhuja Durga
              </Typography>
            </Grid>
            <GridTableComponent
              tableData={TableDataForDasapuja}
              columnMapping={columnMappingForDasapuja}
            />
            <Grid sx={{ margin: "20px 0 20px 0" }}>
              <Typography className={styles.typoGraphyHeading}>
                Parvati & Dasabhuja Durga
              </Typography>
            </Grid>
            <GridTableComponent
              tableData={TableDataForParvati}
              columnMapping={columnMapping}
            />
            <Grid sx={{ margin: "20px 0 20px 0" }}>
              <Typography className={styles.typoGraphyHeading}>
                Kanaka Durga
              </Typography>
            </Grid>
            <GridTableComponent
              tableData={tableKanakaDurga}
              columnMapping={columnMapping}
            />
            <Grid sx={{ margin: "20px 0 20px 0" }}>
              <Typography className={styles.typoGraphyHeading}>
                Karthikeya
              </Typography>
            </Grid>
            <GridTableComponent
              tableData={TableKarthikeya}
              columnMapping={columnMapping}
            />
            <Grid sx={{ margin: "20px 0 20px 0" }}>
              <Typography className={styles.typoGraphyHeading}>
              Saraswati
              </Typography>
            </Grid>
            <GridTableComponent
              tableData={tableSaraswathi}
              columnMapping={columnMapping}
            />
            <Grid sx={{ margin: "20px 0 20px 0" }}>
              <Typography className={styles.typoGraphyHeading}>
                Ayyappa
              </Typography>
            </Grid>
            <GridTableComponent
              tableData={tableAyyappa}
              columnMapping={columnMapping}
            />
            <Grid sx={{ margin: "20px 0 20px 0" }}>
              <Typography className={styles.typoGraphyHeading}>
              Navagraha
              </Typography>
            </Grid>
            <GridTableComponent
              tableData={tableNavagraha}
              columnMapping={columnMapping}
            />
             <Grid sx={{ margin: "20px 0 20px 0" }}>
              <Typography className={styles.typoGraphyHeading}>
              Kalabairava
              </Typography>
            </Grid>
            <GridTableComponent
              tableData={tableKalabhairava}
              columnMapping={columnMapping}
            />
             <Grid sx={{ margin: "20px 0 20px 0" }}>
              <Typography className={styles.typoGraphyHeading}>
              Nandi
              </Typography>
            </Grid>
            <GridTableComponent
              tableData={tableNandi}
              columnMapping={columnMapping}
            />
             <Grid sx={{ margin: "20px 0 20px 0" }}>
              <Typography className={styles.typoGraphyHeading}>
              Venkateswara (Balaji)
              </Typography>
            </Grid>
            <GridTableComponent
              tableData={TableVenkateshwara}
              columnMapping={columnMapping}
            />
             <Grid sx={{ margin: "20px 0 20px 0" }}>
              <Typography className={styles.typoGraphyHeading}>
              Andal (Bhudevi)
              </Typography>
            </Grid>
            <GridTableComponent
              tableData={TableAndalBoodhevi}
              columnMapping={columnMapping}
            />
             <Grid sx={{ margin: "20px 0 20px 0" }}>
              <Typography className={styles.typoGraphyHeading}>
              Maha Lakshmi
              </Typography>
            </Grid>
            <GridTableComponent
              tableData={TableMahaLakshmi}
              columnMapping={columnMapping}
            />
             <Grid sx={{ margin: "20px 0 20px 0" }}>
              <Typography className={styles.typoGraphyHeading}>
              Rama
              </Typography>
            </Grid>
            <GridTableComponent
              tableData={TableRama}
              columnMapping={columnMapping}
            />
             <Grid sx={{ margin: "20px 0 20px 0" }}>
              <Typography className={styles.typoGraphyHeading}>
              Krishna
              </Typography>
            </Grid>
            <GridTableComponent
              tableData={tableKrishna}
              columnMapping={columnMapping}
            />
             <Grid sx={{ margin: "20px 0 20px 0" }}>
              <Typography className={styles.typoGraphyHeading}>
              Narasimha
              </Typography>
            </Grid>
            <GridTableComponent
              tableData={tableNarasimha}
              columnMapping={columnMapping}
            />
             <Grid sx={{ margin: "20px 0 20px 0" }}>
              <Typography className={styles.typoGraphyHeading}>
              Anjaneya
              </Typography>
            </Grid>
            <GridTableComponent
              tableData={tableAnjaneya}
              columnMapping={columnMapping}
            />
             <Grid sx={{ margin: "20px 0 20px 0" }}>
              <Typography className={styles.typoGraphyHeading}>
              Dwara Ganapathi, Nagaraja, Garuda
              </Typography>
            </Grid>
            <GridTableComponent
              tableData={tableDwarakaLast}
              columnMapping={columnMapping}
            />
          </div>
        </div>
      </div>
    </>
  );
};
export default WeeklyMonthlySerrvices;
